/**
 * Where customers write to us. Shown in the app and set as the reply-to on
 * every email the app sends, so a reply reaches a person.
 *
 * A Gmail inbox for now (Emmanuel's choice on 26 October 2026, to avoid a
 * Google Workspace subscription at launch). When it moves to
 * support@thegoodstock.co.uk, this is the one line to change.
 */
export const SUPPORT_EMAIL = 'thegoodstock.support@gmail.com';
//# sourceMappingURL=support.js.map